import { render, staticRenderFns } from "./SocialMediaPost.vue?vue&type=template&id=642da350&scoped=true"
import script from "./SocialMediaPost.vue?vue&type=script&lang=js"
export * from "./SocialMediaPost.vue?vue&type=script&lang=js"
import style0 from "./SocialMediaPost.vue?vue&type=style&index=0&id=642da350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642da350",
  null
  
)

export default component.exports